module.exports = __webpack_public_path__ + "static/media/Image_22.787fc42a.png";